if (!customElements.get('ofiyaa-marquee')) {
  class OfiyaaMarquee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.scroller = this.querySelector('.ofiyaa-marquee__scroller');
      this.group = this.querySelector('.ofiyaa-marquee__group');

      if (!this.scroller || !this.group) return;

      this.speed = parseFloat(this.getAttribute('speed')) || 0.3;
      this.build = this.build.bind(this);

      const images = this.group.querySelectorAll('img');

      if (images.length) {
        let loadedImages = 0;
        const onImageReady = () => {
          loadedImages += 1;
          if (loadedImages >= images.length) this.build();
        };

        images.forEach((image) => {
          if (image.complete) {
            onImageReady();
          } else {
            image.addEventListener('load', onImageReady, { once: true });
            image.addEventListener('error', onImageReady, { once: true });
          }
        });
      } else {
        this.build();
      }

      this.resizeObserver = new ResizeObserver(() => this.build());
      this.resizeObserver.observe(this);

      if (this.hasAttribute('pause-on-hover')) {
        this.addEventListener('pointerenter', () => {
          if (this.scroller) this.scroller.style.animationPlayState = 'paused';
        });
        this.addEventListener('pointerleave', () => {
          if (this.scroller) this.scroller.style.animationPlayState = 'running';
        });
      }

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (this.scroller) {
                this.scroller.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
              }
            });
          },
          { rootMargin: '200px' }
        );
        this.intersectionObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
    }

    build() {
      if (!this.scroller || !this.group) return;

      const groupWidth = this.group.getBoundingClientRect().width;
      const hostWidth = this.getBoundingClientRect().width;

      if (!groupWidth || !hostWidth) return;

      this.scroller.querySelectorAll('[data-marquee-clone]').forEach((node) => node.remove());

      const duplicateCount = Math.ceil(hostWidth / groupWidth);

      for (let i = 1; i <= duplicateCount; i += 1) {
        for (let y = 0; y < 2; y += 1) {
          const clone = this.group.cloneNode(true);
          const offset = 100 * i * (y % 2 === 0 ? -1 : 1);

          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-marquee-clone', '');
          clone.style.cssText = `position: absolute; inset-inline-start: calc(${offset}%);`;
          clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          this.scroller.appendChild(clone);
        }
      }

      this.scroller.style.setProperty('--marquee-duration', `${groupWidth / 300 / this.speed}s`);
      this.dataset.initialized = 'true';
    }
  }

  customElements.define('ofiyaa-marquee', OfiyaaMarquee);
}
